import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-notification-footer',
  standalone: true,
  imports: [],
  templateUrl: './notification-footer.component.html',
  styleUrl: './notification-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
// eslint-disable-next-line @tseslint/no-extraneous-class
export class NotificationFooterComponent {}
